export enum ProductServiceType {
  MDR = 1,
  MDR_MANAGER = 2,
}
